(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["progear-attribute-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function(event) {
  var summary = event.target.closest('.pg-attribute-group > summary');
  if (!summary) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  var group = summary.parentElement;
  group.open = !group.open;
  summary.setAttribute('aria-expanded', group.open ? 'true' : 'false');
}, true);
  } catch(e) { console.error(e); }
})();

})();
